import {
  joinHTML
} from '../HTML.lib';

/**
 * Subject template for  a 10x10 notification,
 * when a user agrees to terms to see a job or candidate engagements.
 * 
 * @param {string} USER__NAME - [plaintext] the name of the user
 * @param {string} TERMS__VERSION - [plaintext] the version of the terms accepted
 */
export const TEMPLATE__SUBJECT__USER_AGREED_ENGAGEMENTS_TERMS = `[System Notification] {{USER__NAME}} agreed to terms {{TERMS__VERSION}} for candidate consent, job info and feedback`;

/**
 * Body template for  a 10x10 notification,
 * when a user agrees to terms to see a job or candidate engagements.
 * 
 * @param {string} USER__ID - [plaintext] the ID of the user
 * @param {string} USER__NAME - [plaintext] the name of the user
 * @param {string} USER__EMAIL - [plaintext] the email of the user
 * @param {string} USER__PHONE - [plaintext] the phone of the user
 * @param {string} USER__AGENCY__NAME - [plaintext] the name of the user agency
 * @param {string} PAGE__NAME - [plaintext] the name of the page
 * @param {string} TIMESTAMP__ACCEPTED__DATE_TIME__UTC - [plaintext] the timestamp when the user accepted
 * @param {string} IP__ADDRESS - [plaintext] the IP address of the user
 * @param {string} TERMS__VERSION - [plaintext] the version of the terms accepted
 */
export const TEMPLATE__BODY__USER_AGREED_ENGAGEMENTS_TERMS = joinHTML(`
  <b>User ID/Name:</b> <small>{{USER__ID}}</small> / {{USER__NAME}}, {{USER__AGENCY__NAME}}, {{USER__EMAIL}}, {{USER__PHONE}}</br>
  <b>Page</b> {{PAGE__NAME}}</br>
  <b>Timestamp of Acceptance:</b> {{TIMESTAMP__ACCEPTED__DATE_TIME__UTC}}</br>
  <b>IP Address:</b> {{IP__ADDRESS}}</br>
  <b>Terms Version:</b> {{TERMS__VERSION}}</br></br>
  {{{TERMS__HTML}}}
`);

export const VERSION__CURRENT__ENGAGEMENTS_TERMS = 'v1.0';
export const HTML__CURRENT__ENGAMENT_TERMS = joinHTML(`
  <div>
    <div>
      <b>Candidate Consent Required for Submission</b>
    </div>
    <br />
    <div>
      You confirm, on behalf of your team, that you've spoken with the candidate via voice or video and received explicit permission to submit them. If there's a dispute, you agree to provide proof (e.g. a timestamped message or note).
    </div>
    <br />
    <div>
      <b>Feedback is strictly confidential</b> and intended solely to help you improve future submissions.
    </div>
    <br />
    <div>
      <b>Confidential Data Use</b>
    </div>
    <br />
    <div>
      You confirm, on behalf of your team, that all information we provide-search criteria, feedback, and non-public employer details-will be <b>used exclusively</b> to source for our roles.
    </div>
    <br />
    <div>
      All data is provided on a best-effort basis. This information is <b>strictly confidential</b> and must not be shared with candidates or anyone outside your team.
    </div>
    <br />
    <div>
      <b>Misuse is prohibited and will result in removal from the platform.</b> It creates unnecessary overhead, confusion, misrepresentation, and risk for all parties.
    </div>
    <br />
    <div>
      <b>Note:</b> You'll need to accept these terms each time you log in.
    </div>
  </div>
`);